import React, { useEffect } from 'react';
import { useAuth } from '../../../services/contexts';
import { backendForFrontend } from '../../../services/utils/axios';
import { Spacer, View } from '../../UserDetail/styles';
import {
  Skeleton,
  Stack,
  Typography,
  Typography as MuiTypography,
  CardContent,
  styled,
  List as MuiList,
  ListItem as MuiListItem,
} from '@mui/material';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';

const List = styled(MuiList)(({ theme }) => ({
  paddingLeft: 0,
}));

const ListItem = styled(MuiListItem)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  paddingLeft: 0,
  alignItems: 'center',
  justifyContent: 'space-between',
}));

function ConfirmOperatorContactInformationUpdate({
  payload,
  submit,
  setError,
  setSubmit,
  openFeedback,
}) {
  const { t } = useTranslation();
  const { token } = useAuth();

  useEffect(() => {
    if (submit > 0) updateOperator();
    setSubmit(0);
  }, [submit]);

  const updateOperator = async () => {
    try {
      await backendForFrontend.put(
        '/cpos/update-operator-information',
        {
          ...payload,
          workFlow: 'ContactInfo',
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      openFeedback();
    } catch (error) {
      setError(true);
    }
  };

  return (
    <>
      <View>
        <CardContent>
          <Spacer mb={4} />
          <Stack direction="row" sx={{ width: '100%' }}>
            <Box flexGrow={1}>
              <MuiTypography variant="h3" component="h2" gutterBottom>
                {t('LBLOperatorContactInformation')}
              </MuiTypography>

              <ListItem>
                <Typography>{t('LBLOperatorGenericInfoSection')}</Typography>

                <Typography align="right">
                  <Typography sx={{ textAlign: 'right' }}>
                    {[
                      {
                        label: 'LBLContactPersonName',
                        value: payload?.contactPersonDetails?.contactPersonName,
                      },
                      {
                        label: 'LBLContactPersonPosition',
                        value:
                          payload?.contactPersonDetails?.contactPersonPosition,
                      },
                      {
                        label: 'LBLContactPersonEmail',
                        value:
                          payload?.contactPersonDetails?.contactPersonEmail,
                      },
                      {
                        label: 'LBLContactPersonPhone',
                        value:
                          payload?.contactPersonDetails?.contactPersonPhone,
                      },
                    ]
                      .filter(
                        (item) =>
                          item.value && String(item.value).trim().length > 0
                      )
                      .map((item) => (
                        <div key={item.label}>
                          <strong>{t(item.label)}:</strong> {item.value}
                        </div>
                      ))}
                  </Typography>
                </Typography>
              </ListItem>

              <ListItem>
                <Typography>
                  {t('LBLOperatorBillingRelatedInfoSection')}
                </Typography>

                <Typography align="right">
                  <Typography sx={{ textAlign: 'right' }}>
                    {[
                      {
                        label: 'LBLContactPersonName',
                        value:
                          payload?.bookkeepingContactPersonDetails
                            ?.contactPersonName,
                      },
                      {
                        label: 'LBLContactPersonPosition',
                        value:
                          payload?.bookkeepingContactPersonDetails
                            ?.contactPersonPosition,
                      },
                      {
                        label: 'LBLContactPersonEmail',
                        value:
                          payload?.bookkeepingContactPersonDetails
                            ?.contactPersonEmail,
                      },
                      {
                        label: 'LBLContactPersonPhone',
                        value:
                          payload?.bookkeepingContactPersonDetails
                            ?.contactPersonPhone,
                      },
                    ]
                      .filter(
                        (item) =>
                          item.value && String(item.value).trim().length > 0
                      )
                      .map((item) => (
                        <div key={item.label}>
                          <strong>{t(item.label)}:</strong> {item.value}
                        </div>
                      ))}
                  </Typography>
                </Typography>
              </ListItem>

              <ListItem>
                <Typography>{t('LBLOperatorTechnicalInfoSection')}</Typography>

                <Typography align="right">
                  <Typography sx={{ textAlign: 'right' }}>
                    {[
                      {
                        label: 'LBLContactPersonName',
                        value:
                          payload?.technicianContactDetails?.contactPersonName,
                      },
                      {
                        label: 'LBLContactPersonPosition',
                        value:
                          payload?.technicianContactDetails
                            ?.contactPersonPosition,
                      },
                      {
                        label: 'LBLContactPersonEmail',
                        value:
                          payload?.technicianContactDetails?.contactPersonEmail,
                      },
                      {
                        label: 'LBLContactPersonPhone',
                        value:
                          payload?.technicianContactDetails?.contactPersonPhone,
                      },
                    ]
                      .filter(
                        (item) =>
                          item.value && String(item.value).trim().length > 0
                      )
                      .map((item) => (
                        <div key={item.label}>
                          <strong>{t(item.label)}:</strong> {item.value}
                        </div>
                      ))}
                  </Typography>
                </Typography>
              </ListItem>
            </Box>
          </Stack>
        </CardContent>
      </View>
    </>
  );
}
export default ConfirmOperatorContactInformationUpdate;
